<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.mobile_feature.notification.schedule.schedule') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t(
              'administration.mobile_feature.notification.schedule.schedule'
            ),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row m-b-15">
              <div class="col-md-12">
                <label>
                  {{
                    $t(
                      'administration.mobile_feature.notification.schedule.notification_type'
                    )
                  }}
                  <span class="text-danger">*</span>
                </label>
                <select
                  v-model.number="model.not_type_id"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('not_type_id') }"
                >
                  <option value=""
                    >--{{
                      $t(
                        'administration.mobile_feature.notification.schedule.select'
                      )
                    }}--</option
                  >
                  <option
                    v-for="(notification_type, index) in notification_types"
                    :key="index"
                    :value="notification_type.not_type_id"
                  >
                    {{ notification_type.not_type }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('not_type_id')">
                  {{ errors.first('not_type_id') }}
                </div>
              </div>
            </div>
            <div class="row m-b-15">
              <div class="col-md-12">
                <label>
                  {{
                    $t(
                      'administration.mobile_feature.notification.schedule.notify_before'
                    )
                  }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model.number="model.num_day_alert"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('num_day_alert') }"
                />
                <div
                  class="invalid-feedback"
                  v-if="errors.has('num_day_alert')"
                >
                  {{ errors.first('num_day_alert') }}
                </div>
              </div>
            </div>
            <div class="row m-b-15">
              <div class="col-md-12">
                <label>{{
                  $t(
                    'administration.mobile_feature.notification.schedule.comment'
                  )
                }}</label>
                <textarea
                  v-model.number="model.comment"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('comment') }"
                  rows="3"
                ></textarea>
                <div class="invalid-feedback" v-if="errors.has('comment')">
                  {{ errors.first('comment') }}
                </div>
              </div>
            </div>
            <div class="row m-b-15">
              <div class="col-md-12">
                <ts-checkbox v-model="model.inactive">
                  {{
                    $t(
                      'administration.mobile_feature.notification.schedule.inactive'
                    )
                  }}
                </ts-checkbox>
              </div>
            </div>
            <div class="row text-right">
              <div class="col-md-12">
                <ts-button
                  v-if="updated"
                  class="btn-default mr-2"
                  @click.prevent="cancel"
                >
                  {{ $t('cancel') }}
                </ts-button>
                <ts-button
                  v-if="updated == false"
                  class="btn-primary"
                  :waiting="waiting"
                  @click.prevent="save"
                >
                  {{ $t('save') }}
                </ts-button>
                <ts-button
                  v-if="updated"
                  class="btn-primary"
                  :waiting="waiting"
                  @click.prevent="update"
                >
                  {{ $t('update') }}
                </ts-button>
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table
          :fetch="fetchData"
          @fetched="fetchData = false"
        ></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from './table'
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'notification-schedule',
  components: { DataTable },
  data() {
    return {
      model: {
        not_sch_id: '',
        not_type_id: '',
        num_day_alert: '',
        comment: '',
        inactive: false
      },
      errors: new Errors(),
      waiting: false,
      fetchData: false,
      updated: false
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('notificationSchedule', ['notification_types', 'edit_data'])
  },
  methods: {
    save() {
      this.waiting = true
      this.$store
        .dispatch('notificationSchedule/store', Object.assign({}, this.model))
        .then(response => {
          this.clearFormInput()
          this.waiting = false
          this.$toasted.success(response.message)
          this.fetchData = true
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },

    update() {
      this.waiting = true
      this.$store
        .dispatch('notificationSchedule/update', Object.assign({}, this.model))
        .then(response => {
          this.clearFormInput()
          this.waiting = false
          this.$toasted.success(response.message)
          this.fetchData = true
          this.updated = false
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },

    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.errors = new Errors()
        this.updated = true
        this.model.not_sch_id = this.edit_data.not_sch_id
        this.model.not_type_id = this.edit_data.not_type_id
        this.model.num_day_alert = this.edit_data.num_day_alert
        this.model.comment = this.edit_data.comment
        this.model.inactive = this.edit_data.inactive
      }
    },

    clearFormInput() {
      this.model.not_type_id = ''
      this.model.num_day_alert = ''
      this.model.comment = ''
      this.model.inactive = false
    },
    cancel() {
      this.updated = false
      this.fetchData = true
      this.clearFormInput()
      this.$router.push({ name: 'notification-schedule' })
    }
  },
  watch: {
    edit_data: {
      handler(val) {
        this.setEditData()
      },
      deep: true
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('notificationSchedule/RESET_STATE')
      this.$store.commit('notificationSchedule/SET_EDIT_DATA', {})
    }
    next()
  }
}
</script>
